// extracted by mini-css-extract-plugin
export default {"wrap":"s_wrap__hpKvr"};